import BusStopIconOrigin from 'design-system/svg/map-icon-bus-origin.svg?react';
import BusStopIconDestination from 'design-system/svg/map-icon-bus-destination.svg?react';
import BusStopIconWaypoint from 'design-system/svg/map-icon-bus-waypoint.svg?react';
import { renderToStaticMarkup } from 'react-dom/server';
import { BusDelayStatus } from 'design-system/atoms/custom-google-map/map-layer-buses';

type BusStopType = 'origin' | 'destination' | 'waypoint';
interface BusRouteSegment {
  firstStop: { stopId: string };
  lastStop: { stopId: string };
}
interface BusRouteStopIconProps {
  color: string;
  stopType: BusStopType;
  boxSize?: number;
}

export default function BusRouteStopIcon({
  color,
  stopType,
  boxSize,
}: BusRouteStopIconProps) {
  if (stopType === 'origin') {
    return (
      <BusStopIconOrigin
        style={{ display: 'inline-block' }}
        width={boxSize ? `${boxSize}px` : undefined}
        height={boxSize ? `${boxSize}px` : undefined}
        color={color}
      />
    );
  }
  if (stopType === 'destination') {
    return (
      <BusStopIconDestination
        style={{ display: 'inline-block' }}
        width={boxSize ? `${boxSize}px` : undefined}
        height={boxSize ? `${boxSize}px` : undefined}
        color={color}
      />
    );
  }
  return (
    <BusStopIconWaypoint
      style={{ display: 'inline-block', transform: 'scale(0.5)' }}
      width={boxSize ? `${boxSize}px` : undefined}
      height={boxSize ? `${boxSize}px` : undefined}
      color={color}
    />
  );
}

export function getBusStopStatus({
  busSchedule,
  stopId,
}: {
  busSchedule: {
    stopId: string;
    arrivalDelay?: number;
    departureDelay?: number;
    scheduledArrivalTime?: number;
    scheduledDepartureTime?: number;
    arrivalTime?: number;
    departureTime?: number;
  }[];
  stopId: string;
}): BusDelayStatus {
  const stop = busSchedule.find((s) => s.stopId === stopId);
  if (
    !stop ||
    (stop.arrivalDelay === undefined && stop.departureDelay === undefined)
  ) {
    return 'no-data';
  }
  const delay = stop.arrivalDelay || stop.departureDelay || 0;
  if (delay > 5 * 60 * 1000) {
    return 'severe-delay';
  }
  if (delay < 60 * 1000) {
    return 'on-time';
  }
  return 'delay';
}
export function getBusStopType({
  routeSegment,
  stopId,
}: {
  routeSegment: BusRouteSegment;
  stopId: string;
}): BusStopType {
  if (routeSegment.firstStop.stopId === stopId) {
    return 'origin';
  }
  if (routeSegment.lastStop.stopId === stopId) {
    return 'destination';
  }
  return 'waypoint';
}

export function getBusRouteStopIconUrl({
  color,
  stopType,
  boxSize,
}: {
  color: string;
  stopType: BusStopType;
  boxSize?: number;
}) {
  return `data:image/svg+xml,${encodeURIComponent(
    renderToStaticMarkup(
      <BusRouteStopIcon stopType={stopType} color={color} boxSize={boxSize} />
    )
  )}`;
}
